import { call, put, takeLatest } from "redux-saga/effects";
import * as types from "./types";
import apiClient from "../api";
import mappers from "./mappers";
import ActionType from "../../Models/ActionType";

function* handleFetchWorkers(action: ActionType) {
  try {
    const { data } = yield call(apiClient.get, "workers/");
    const workers = data.map((d: any) => mappers.worker.mapToWorker(d));
    yield put({ type: types.FETCH_WORKERS_SUCCESS, payload: workers });
  } catch (e: any) {
    yield put({ type: types.FETCH_WORKERS_FAILURE });
    console.log(e);
  }
}

const workerSagas = [takeLatest(types.FETCH_WORKERS, handleFetchWorkers)];

export default workerSagas;
